import { render, staticRenderFns } from "./video-control.vue?vue&type=template&id=33e106c7&lang=pug&"
import script from "./video-control.vue?vue&type=script&lang=js&"
export * from "./video-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports